module.exports = __webpack_public_path__ + "img/products__back.a2374544.jpg";